import { FirstDayWizardStep } from '@app/models/first-day-step';

export class User {
  // The user principal name and identifier in db.
  public UpnId: string;
  public ShowNewsFromFollowedSites: boolean;
  public FirstDayWizardStep: FirstDayWizardStep;

  constructor(opt?: Partial<User>) {
    Object.assign(this, opt);
  }
}
